import { createFileRoute, Navigate } from "@tanstack/react-router";

import SettingsPage from "@/pages/settings/SettingsPage";

import { FeatureFlag, useFeatureFlag } from "@/hooks/useFeatureFlag";

export const Route = createFileRoute("/_secure/settings/api-key")({
  component: RouteComponent,
});

function RouteComponent() {
  const isEnabled = useFeatureFlag(FeatureFlag.WORKSPACE_SETTINGS_API_ENABLED);

  if (!isEnabled) {
    return <Navigate to="/settings/general" />;
  }

  return <SettingsPage route="/settings/api-key" />;
}
